import { HandySvg } from "handy-svg";
import styles from "./blockEight.module.scss";
import Image from "next/image";
import Link from "next/link";

export default function BlockEight({ data, isAllLandingsPage = false, dictionary = null }) {
	return (
		<section className={`${styles.section} ${isAllLandingsPage ? styles.all : ""}`}>
			{dictionary !== null && (
				<>
					<h1 className={styles.title}>{dictionary["page_landings_h1"] || "Transform Your Visuals with Bgrem's AI-Powered Tools"}</h1>
					<p className={styles.description}>
						{dictionary["page_landings_descriptor"] ||
							"Explore the robust features and tools available in Bgrem that make it easy to create and edit amazing visuals. No experience required - start your journey with Bgrem today!"}
					</p>
				</>
			)}
			<div className={styles.itemsWrapper}>
				{data.map((item) => {
					const itemData = item.attributes;
					const imgData = item.attributes.Top.Main_image.data.attributes;
					const url = itemData.SEO.Linck_name;
					const name = itemData.Top.Title;

					return (
						<Link className={styles.item} key={item.id} href={`/landings/${url}`}>
							<Image src={imgData.url} alt={imgData.alternativeText} width={imgData.width} height={imgData.height} loading="lazy" unoptimized={true} />
							<div className={styles.name}>
								{name}
								<HandySvg src={"/illustration_service/next.svg"} width={24} height={24} fill={"transparent"} />
							</div>
						</Link>
					);
				})}
			</div>
		</section>
	);
}
